module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "checkbox1"
    },
    domProps: {
      "value": _vm.value
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox1"
    }
  }, [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5789da86"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/checkbox.vue
// module id = 1222
// module chunks = 1